import Imgix from 'react-imgix';
import { IListItem, ListProductReferrer } from '../../list-page/interfaces/interfaces';
import { sendGAListPageEvent } from '../../../domain/marketing/gtm-provider';
import { CSSProperties } from 'react';
import ProductWishlist from '../product-wishlist/product-wishlist';

interface IProductImageProps {
    product: IListItem,
    removeImgLink?: boolean,
    style?: CSSProperties,
    classes?: string,
    listName?: string,
    imageHeight?: string,
    disableImageLazy?: boolean;
    referrer?: ListProductReferrer;
    showSuperSaleBadge?: boolean;
}

const IMG_SMALL_SIZE = 150;

const getImageSize = (style?: CSSProperties) : {
    size: number,
    style?: CSSProperties
} => {
    const _style = style ?? {};
    _style.height = `200px`;

    return {
        size: IMG_SMALL_SIZE,
        style: _style,
    };
};

/**
 * Product image.
 * https://docs.imgix.com/libraries/react-imgix#lazy-loading
 */
const ProductImage = (props: IProductImageProps) => {

    const product = props.product;
    let _style = props.style;

    /*auto height (defaulr = 150)*/
    let height : any = 150;
    let autoHeightCss = 'px-4 bg-gray-100';

    if(props?.imageHeight) {
        autoHeightCss = '';

        if(props?.imageHeight === 'auto')
            height = undefined
        else
            height = props?.imageHeight;
    }
    else{
        const { size, style } = getImageSize(props.style);
        height = size;
        _style = style;
    }

    const getImage = () => {
        return (
            product.thumb ?
                <Imgix
                    src={ product.thumb }
                    height={ height }
                    htmlAttributes={{
                        alt: `Image for ${ product.documentName }`,
                        loading: props.disableImageLazy ? undefined : 'lazy',
                    }}
                    disableQualityByDPR
                /> : <div />
        )
    };

    /*const getImage = () => {
        return (
            product.thumb ?
            <Imgix
                className="lazyload"
                src={ product.thumb }
                height={ height }
                attributeConfig={{
                    src: 'data-src',
                    srcSet: 'data-srcset',
                    sizes: 'data-sizes',
                }}
                htmlAttributes={{
                    alt: `Image for ${ product.documentName }`
                }}
                disableQualityByDPR
            /> : <div />
        )
    };
*/
    const getBadge = () => {
        return <div className={ `text-sm text-center text-white absolute px-4 py-1 left-0 bottom-0 ${ product.badgeClass }` }>{ product.badgeText }</div>    ;
    };

    const onClick = () => {
        sendGAListPageEvent(product, props.listName);
    };

    const superSaleBadge = () => {
        return (
            <div
                style={{
                    transform: 'translate(27%, 100%) rotate(45deg)',
                    letterSpacing: '0.7px',
                    transformOrigin: 'center',
                    'boxShadow': '0px 5px 5px rgb(0, 0, 0, 10%)',
                }}
                className="absolute w-36 bg-red py-1 text-center text-xs font-bold  text-white top-0 right-0"
            >
                SUPER SALE
            </div>
        );
    };

    const blackFridayBadge = () => {
        return (
            <div
                style={{
                    transform: 'translate(27%, 100%) rotate(45deg)',
                    letterSpacing: '0.7px',
                    transformOrigin: 'center',
                    'boxShadow': '0px 5px 5px rgb(0, 0, 0, 10%)',
                }}
                className="absolute w-36 bg-red py-1 text-center text-xs font-bold  text-white top-0 right-0"
            >
                Black Friday
            </div>
        );
    };

    const hasSuperSaleBadge = !!props.showSuperSaleBadge && product.discount >= 75;

    const isListPage = !!document.querySelector('meta[property="google-ecomm-pagetype"][content="category"]');
    const hasBlackFridayBadge = isListPage && product.msrp > product.skuPrice;

    return (
        <>
            {
                props.removeImgLink && (
                    <div
                        data-type="product-image"
                        className={`${ autoHeightCss } flex justify-center items-center relative ${ (hasSuperSaleBadge || hasBlackFridayBadge) ? 'overflow-hidden' : '' } ${ props.classes }`}
                        title={ product.documentName }
                        style={ _style }>
                        { getImage() }
                        { product.badgeText && getBadge() }
                        { hasSuperSaleBadge && superSaleBadge() }
                        { hasBlackFridayBadge && blackFridayBadge() }
                    </div>
                )
            }

            {
                !props.removeImgLink &&
                <div>
                    <a
                        data-type="product-image"
                        href={product.documentUrlPath}
                        className={`${autoHeightCss} flex justify-center items-center relative ${ (hasSuperSaleBadge || hasBlackFridayBadge) ? 'overflow-hidden' : '' } ${props.classes}`}
                        title={product.documentName}
                        style={ _style }
                        onClick={onClick}>
                        { getImage() }
                        { product.badgeText && getBadge() }
                        { hasSuperSaleBadge && superSaleBadge() }
                        { hasBlackFridayBadge && blackFridayBadge() }
                    </a>
                </div>
            }

            { product.isWishlist && <ProductWishlist skuid={ product.skuid } /> }
        </>
    )
};

export default ProductImage;
